import * as types from 'constants/actionTypes';
import * as Rx from 'rxjs';
const { Observable } = Rx;
const { of, ajax } = Observable;
import * as actions from 'actions/justAskActions';
const apiUrls = require('constants/apiUrls');
import * as mouseFlowUtils from '../utils/mouseFlowUtils';
import {
  TAG_ADD_JUST_ASK_ITEMS
  , TAG_UPDATE_JUST_ASK_ITEMS
} from '../constants/mouseFlow';
import { wowCustomHeader } from '../utils/wowCustomHeadersUtils';
import { getAccessTokenFromState } from 'utils/userManager';

export const indirect = {
  call: (fn, ...args) => fn(...args)
};

export const api = {
  addJustAsk: (request, store) => {

    const state = store.getState();
    const accessToken = getAccessTokenFromState(state);

    const wowHeaders = wowCustomHeader(state);

    request.username = state
      .getIn(['user', 'userId']);

    mouseFlowUtils.setNewPageView(apiUrls.JUST_ASK_ADD_URL);
    mouseFlowUtils.setTag(TAG_ADD_JUST_ASK_ITEMS);

    return ajax({
      url: apiUrls.JUST_ASK_ADD_URL,
      method: 'POST',
      body: request,
      responseType: 'json',
      crossDomain: true,
      timeout: apiUrls.API_TIMEOUT,
      headers: {
        ...wowHeaders,
        'Content-Type': 'application/x-www-form-urlencoded',
        'authorization': 'Bearer ' + accessToken
      }
    });
  },
  updateJustAsk: (request, store) => {

    const state = store.getState();
    const accessToken = getAccessTokenFromState(state);

    const wowHeaders = wowCustomHeader(state);

    mouseFlowUtils.setNewPageView(apiUrls.JUST_ASK_UPDATE_URL);
    mouseFlowUtils.setTag(TAG_UPDATE_JUST_ASK_ITEMS);

    return ajax({
      url: apiUrls.JUST_ASK_UPDATE_URL,
      method: 'PUT',
      body: request,
      responseType: 'json',
      crossDomain: true,
      timeout: apiUrls.API_TIMEOUT,
      headers: {
        ...wowHeaders,
        'Content-Type': 'application/x-www-form-urlencoded',
        'authorization': 'Bearer ' + accessToken
      }
    });
  }
};

export const addJustAskEpic = (action$, store, call = indirect.call) => action$
  .ofType(types.JUST_ASK_ADD_STARTED)
  .mergeMap(action => call(api.addJustAsk, action.request, store).map((payload) => {

    return (actions.justAskAddFinished(payload.response, action.orderId));
  }).catch(() => of(actions.justAskAddFailed(action.request, action.orderId))));

export const updateJustAskEpic = (action$, store, call = indirect.call) => action$
  .ofType(types.JUST_ASK_UPDATE_STARTED)
  .mergeMap(action => call(api.updateJustAsk, action.request, store).map(() => {

    return (actions.justAskUpdateFinished(action.request, action.orderId));
  }).catch(() => of(actions.justAskUpdateFailed(action.request, action.orderId))));



// WEBPACK FOOTER //
// ./src/epics/justAskEpics.js